export const getRoleColor = (role: string): string | undefined => {
  switch (role) {
    case 'BUSINESS_ADMINISTRATOR':
      return 'red';
    case 'BUSINESS_MANAGER':
      return 'purple';
    case 'BUSINESS_CASHIER':
      return 'green';
    default:
      return undefined;
  }
};
